export const COLORS = {
  primary: '#006F98',
  primaryDark: '#165874',
  primaryLight: '#319ED8',
  secondary: '#0B2E4F',
  secondaryDark: '#1D2D3D',
  secondaryLight: '#3C5872',
  bgBlueLight: '#D6EDF7',
  bgWhite: '#ffffff',
  grey1: '#F4F6F9',
  grey2: '#EDEFF0',
  grey3: '#C2D1D9',
  grey4: '#627893',
  grey5: '#E1ECF9',
  focus: '#E5F4F9',
  focusAlt: '#C6E3F1',
  yellowCommercial: '#FFBF37',
  yellowCommercialClicked: '#EAB600',
  greenCommercial: '#208838',
  revoked: '#627993',
  buttonBorderRadius: '3.75rem',
  buttonIconBorderRadius: '50%',
  success: '#0D8742',
  successLight: '#E5F4F9',
  info: '#FFC806',
  infoLight: '#FFF3E0',
  warning: '#FFC806',
  warningLight: '#FFF3E0',
  blue: '#0b2e4f',
  error: '#DA100B',
  errorLight: '#F5F5F5',
  light: '#f5f5f5',
  darkBlue: '#0b2e4f',
  text: '#0b2e4f',
  textSecondary: '#8c8c8c',
  textLight: '#ffffff',
  selectionRow: '#e5f4f9',
};
